// ==== Sticky Scroll ==== //

;(function($){
  // Global namespace
  var sticky = sticky || {};

  // Global variables
  var $window       = $(window),
      $document     = $(document),
      $body         = $('body');

  $(function(){

    // Global variables
    var $siteHeader     = $('#masthead'),
        $searchInput    = $('#cases-search-form-1'),
        $depsearchInput = $('.departments-search-1');

    sticky.render = function(elem, pad=true, offset=false) {
      if (elem.length === 0) return;

      var stickyTop = elem.offset().top;

      $window.on('scroll', function() {
        var windowTop = $window.scrollTop();
        if (offset !== false) windowTop += offset.height();

        if (stickyTop < windowTop) {
          elem.addClass('sticky');
          if (pad) $body.css('padding-top', elem.height() + 'px');
          if (offset !== false) elem.css('top', offset.height() + 'px');
        } else {
          elem.removeClass('sticky');
          if (pad) $body.css('padding-top', '0px');
          if (offset !== false) elem.css('top', 'auto');
        }
      });
    }

    sticky.render($siteHeader);
    sticky.render($searchInput, false, $siteHeader);
    sticky.render($depsearchInput, false, $siteHeader);

  });

}(jQuery));
